import { Modal, Switch, Input } from '@citi-icg-172888/icgds-react';
import { useEffect, useState } from 'react';
import { handleInvalidFieldValidation, handleErrorMessage } from '../../services/utils/utils';

export default function CreateCriteriaModal({ size, visible, data, handleCategorySubmission }: any) {
    const [errorMessage, setErrorMessage] = useState("");
    const [isCancel, setCancel] = useState(false);
    const [isCategoryModalVisible, setIsCategoryModalVisible] = useState(visible);
    const [invalidFactor, setInvalidFactor] = useState(false);
    const [invalidScore, setInvalidScore] = useState(false);
    const [title, setTitle] = useState("");
    const [name, setName] = useState("");
    const [factor, setFactor] = useState("");
    const [score, setScore] = useState("");
    const [editable, setEditable] = useState(true);
    const [applicable, setApplicable] = useState(true);

    const handleChange = (ddName: string, e: any) => {   
        switch (ddName) {
            case "title":
                setTitle(e.target.value);
                break;
            case "name":
                setName(e.target.value);
                break;
            case "factor":
                setFactor(e.target.value);
                setInvalidFactor(handleInvalidFieldValidation(ddName, e.target.value) || false);
                break;
            case "score":
                setScore(e.target.value);
                setInvalidScore(handleInvalidFieldValidation(ddName, e.target.value) || false);
                break;
            case "editable":
                setEditable(e.target.checked);
                break;
            case "applicable":
                setApplicable(e.target.checked);
                break;
        }
    }
    const handleSubmit = () => {
        if(!handleErrorMessage({ title, name,  factor,  score, invalidFactor, invalidScore })){
            data[title]=[{ name: name, factor: factor, score: score, editable: editable, applicable: applicable }];
            handleCategorySubmission(data);
            setIsCategoryModalVisible(!isCategoryModalVisible);
        } else{
            setErrorMessage(handleErrorMessage({ title, name,  factor,  score, invalidFactor, invalidScore }))
            setIsCategoryModalVisible(true);
        }        
    }
    useEffect(()=> {
        if(errorMessage.length> 0){
            setIsCategoryModalVisible(true)
        }       
    },[errorMessage.length> 0])

    useEffect(() => {
        if (isCancel) {
            setErrorMessage("");
            setIsCategoryModalVisible(false);
        }
    }, [isCancel])
    
    return (
        <div id="modal_create">
            <Modal
                style={{ width: "100% !important" }}
                size={size}
                visible={errorMessage.length>0 || isCategoryModalVisible}
                title={title}
                onApply={() => handleSubmit()}
                onCancel={() => setCancel(true)}
                closable={false}
            >
                <div className="table">
                    <div className="row">
                        <div className="cell lmn-col-2">Category</div>
                        <div className="cell lmn-col-2">Criteria</div>
                        <div className="cell lmn-col-2">Factor</div>
                        <div className="cell lmn-col-2">Score</div>
                        <div className="cell lmn-col-2">Enable edit</div>
                        <div className="cell lmn-col-2">Enable Rule</div>
                    </div>
                    <div className="row">
                        <div className="cell lmn-col-2">
                            <Input type="text" id='Category' placeholder="Category" value={title} onChange={(e: any) => handleChange("title", e)} />
                        </div>
                        <div className="cell lmn-col-2">
                            <Input type="text" id='Criteria' placeholder="Criteria" value={name} onChange={(e: any) => handleChange("name", e)} />
                        </div>
                        <div className="cell lmn-col-2">
                            <Input invalid={invalidFactor} id='Factor' type="number" placeholder="Factor" value={factor} onChange={(e: any) => handleChange("factor", e)} />
                        </div>
                        <div className="cell lmn-col-2">
                            <Input invalid={invalidScore} id='Score' type="number" placeholder="Score" value={score} onChange={(e: any) => handleChange("score", e)} />
                        </div>
                        <div className="cell lmn-col-2">
                            <Switch size="large" checked={editable} onChange={(e: any) => handleChange("editable", e)}/>
                        </div>
                        <div className="cell lmn-col-2">
                            <Switch size="large" checked={applicable} onChange={(e: any) => handleChange("applicable", e)}/>
                        </div>
                    </div>                    
                </div>
                {errorMessage && <p className='lmn-mt-4 lmn-invalid'>{errorMessage}</p>}
            </Modal>
        </div>
    );
}